export default __webpack_public_path__ + "static/portfolio-emile-ter-huerne-b072ec87a9419b8d5591f65aab74a6b2.png";